import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card"]
  
  blur() {
    this.cardTarget.classList.add(
      "blur-sm",
      "pointer-events-none",
      "opacity-60",
      "transition-all",
      "duration-300",
      "animate-ai-shimmer",
      "bg-ai-gradient"
    )
  }
}